/***
 *
 *   HERO
 *   Hero section on landing page
 *
 *   PROPS
 *   title: h1 title
 *   tagline: h2 tagline
 *   image: source object
 *   alt: img alt tag
 *
 **********/

import { Animate, Content, Image, ClassHelper } from 'components/lib';
import Style from './hero.module.scss';
import { useNavigate } from 'react-router-dom';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';

export function Hero(props) {
	const heroStyle = ClassHelper(Style, {
		hero: true,
		className: props.className,
	});
	const navigate = useNavigate();

	return (
		<section className={heroStyle}>
			<Content>
				<Animate type="pop">
					<section className={Style.blurb}>
						<h1 className={Style.title}>{props.title}</h1>
						<h2 className={Style.tagline}>{props.tagline}</h2>
						{/* <Button goto="/signup" text="Sign Up Now" big className={Style.button} /> */}
						<AivagamButton
							id="signup"
							onClick={() => {
								navigate('/signup')
							}}
							buttonText={'Sign Up'}
							classStyles={{
								fontSize: "1.1em",
								marginBottom: "1.5em",
								boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
								padding: '0.75em 2em'
							}}
						/>
						<br />
						<AivagamButton
							id="signin"
							onClick={() => {
								navigate('/signin')
							}}
							type={"confirm"}
							buttonText={'Sign In'}
							classStyles={{
								fontSize: "1.1em",
								boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
								padding: '0.75em 2em'
							}}

						/>
					</section>
				</Animate>

				<Animate>
					<Image className={Style.image} source={props.image} alt={props.alt} />
				</Animate>
			</Content>
		</section>
	);
}
